/* 
 * Lazy Line Painter - Path Object 
 * Generated using 'SVG to Lazy Line Converter'
 * 
 * http://lazylinepainter.info 
 * Copyright 2013, Cam O'Connell  
 *  
 */ 
 
var pathObj = {
    "svg": {
        "strokepath": [
            {
                "path": "M48.1,30.9c-10.8,9.4-8.8,24-8.8,24c16.9-14.3,26.5-15.6,40.3-15.5s32.3,9.3,31.6,19.3  S100.7,87.8,78,91.1c-22.7,3.2-42.4-16.4-42.4-16.4c-10.3,22.6,2,39.4,19.8,41.7c17.8,2.4,38.3-14.1,44.2-18.8  c5.9-4.8,5.2-3.4,4-0.2c-1.2,3.2-9.3,20.2-9.3,20.2c15.8-3.5,23.8-18,25.4-21.4c1.7-3.4,2.8-11.3,4.7-11.5c1.8-0.2,2.3,6.9,6.7,8.4  c4.4,1.5,6.4,1.7,6.4,5.2c0,3.5-7.8,6.3-5.7,10.6c2,4.3,6.5,0.1,6.5,0.1c0.7-15.3,14.7-21.2,21.8-20.8s11.2,4.6,7.7,9.2  c-3.5,4.6-7.5,10.9-4.7,13c2.8,2.1,4.7-0.7,6.9-3.5s5.2-12.1,7.3-16.2c2.2-4.1,5.4-3,4.5-0.5c-0.9,2.5-4.3,10.5-4.3,10.5  s3.8-4.1,8.6-8.6s10-4.7,8.7-1.8c-1.3,2.8-5.1,13.5-5.4,17.3c-0.3,3.8,0.8,3.6,0.8,3.6l1.8-1.5c0.8-5.7,3.4-14.4,9.3-18.9  c5.9-4.5,14.5-3.5,14.5-3.5s6.9-16.3,10.1-19.5c3.2-3.2,4.9-0.9,3.9,1.4c-1,2.3-7.2,15-12.1,24.5c-4.9,9.5-6,15.3-4.2,16.8  c1.8,1.5,5.3-3.3,5.3-3.3c1.1-10,3.3-15.8,9.3-17.9c6-2.1,7.5,1.9,6.1,7c-1.4,5.1-10.5,12.6-10.5,12.6c3.3,2.9,9.3,1.8,12.9-0.8  c3.6-2.7,6.9-5,6.9-5c-2.5,5.8-3.2,8.8-10.1,12.1s-13.7-3.6-13.7-3.6c-2.7,3.3-5.5,4.9-7.6,4.4c-2.1-0.5-4.9-4.4-4.9-4.4  s-4.7,3.2-7.8,4.4c-3.1,1.1-5.1-3.5-5.1-3.5s-1.3,2.8-4.6,3.6s-6.2-2.6-7.1-7s0-8.5,0-8.5c-2.8,2.6-5.5,6.8-7.4,9.9s-2,5.8-4.6,5.5  s-2.5-3.8-2.5-3.8c-3,4.3-5.6,4.7-8.2,2.1c-2.7-2.6-1.7-5.9-1.7-5.9s-3.4,5.3-8.7,7.2c-5.3,1.9-9.3-3.2-9.3-3.2  c-8.7,7.5-14.7,1.6-15.6-2.7s3.3-9,3.1-11.1c-0.2-2-2.3-2.7-2.3-2.7s-3.3,4.9-10.6,12.8c-7.3,7.9-23.7,14.2-23.7,14.2  s-4.9,12.4-16.1,26.6s-20.8,20.8-25.2,15.9c-4.4-4.9,0.1-20.2,12.7-30.7s25.6-14.6,25.6-14.6c5.4-9.3,7-14.4,7-14.4  c-22,25.4-45.8,22.1-56.9,16.5s-18.4-13.2-18.4-27.2s10.4-29.9,10.4-29.9c-3.7-11.3-0.7-23.4,10-35s26.3-15.6,26.5-14.3  C66.9,17.7,58.9,21.6,48.1,30.9z M41.9,66.1c0,0,9.8,22.5,31.3,19.6s33.6-14.7,34-26.2s-24.3-16-40.3-11.2S41.9,66.1,41.9,66.1z   M65.7,144.8c-7.6,8.2-11.9,15.3-9.7,16.6c2.2,1.3,8.5-5,14.8-12S83.4,128,83.4,128S73.2,136.5,65.7,144.8z M158.2,104.3  c3.8-4.1,5.5-8.8,3.7-9.8c-1.8-1-4.8-0.5-10.1,3.3c-5.3,3.8-7.1,11.9-4.4,12.6C150.2,111.1,154.4,108.4,158.2,104.3z M208.2,104.1  c2.3-2.8,7.4-11.5,5.4-12.2c-2-0.7-5.8,1.5-10,6.3c-4.2,4.8-5,12.1-3.1,12.3C203,110.8,205.8,106.9,208.2,104.1z M228.1,100.1  c1.9-2.8,3.9-6.5,2.2-7.1s-3.9,0.9-5.7,3.4s-3.1,8.6-1.8,8.9C224.5,105.6,226.2,102.8,228.1,100.1z",
                "duration": 1400
            },
            {
                "path": "M123.2,124c10.8-4.6,19-3.7,22.4,5.5c3.4,9.2-2.2,19.1-9,19.6s-7.9-4.4-5.4-8.2  c2.5-3.8,7.1-3.7,5.1-8.5c-2-4.8-7.7-5.2-16.7-0.6s-11.2,24.7-11.2,24.7c3.9-0.4,8.1,2.8,14.6,2.9s15.8-6.8,16.4-6  c0.7,0.8,1,3.1-9.5,10.9s-23.2,2.4-23.2,2.4s2,26.6-17.8,50.1s-39.1,24.2-49.9,16.5c-10.8-7.7-12.6-23.4-8.9-35.3  s11.5-14.7,15.8-11.9c4.3,2.9,0.2,8.3-3.8,13.1c-4,4.9-8.1,15.2,0,21.8s29,0.3,42.5-17.1s16.9-38.5,16.9-38.5s-0.3-0.8-6.6-1.4  S78.5,168.9,78,168s3-6.2,9.3-9.1c6.3-2.9,16.3-3.2,16.3-3.2C104.8,141.1,112.5,128.7,123.2,124z M154.8,128.9  c-3.1,4.3-1.5,11.5,2.5,13.3c4,1.8,9.8-0.8,11.6-5.3s-0.2-10.8-4.4-11.8C160.8,124.3,157.9,124.6,154.8,128.9z M151.9,148.7  c-2.4-2-7.3,2.6-10.7,8.3c-3.3,5.8-5.6,13.7-1.7,17.9c4,4.2,9.9,3.1,15.6-1.1c0,0,1.4,3.7,5.8,3.7c4.4,0,10.9-3.7,10.9-3.7  s0.3,2.4,3.3,3.7s5.8-2,7.1-3.9c0,0-0.5,3.2,0.6,4c1.1,0.8,4.1-1.9,5.6-7.1c1.5-5.2,6.5-12.1,8.3-11.8c0.7,0.1-2.4,8-3.1,10.2  s-2.1,6.6-1.8,8.4c0.1,0.5,3.3,0.7,4.3-1s4.3-10.9,6.1-14.4s4.5-7.2,4.4-3.3c-0.1,3.9-2.1,8.7-2.4,12.7c-0.3,4-0.1,5.1,2.4,6  c2.5,0.8,6.3,0.2,11.7-3.9c0,0,10.6,9.3,29.2-1.3s22.9-31,19.7-43.7s-16.2-25-19.1-23.5c-1.2,0.6,8.4,6,13,17.5s2.8,25.4-6.1,36.8  s-21.8,11.5-26,11.5c0,0,9.4-7,7.9-15.4c-1.5-8.4-10.2-9.1-15.4-3.4c-5.2,5.7-6.9,10.1-4.7,18.2c0,0-5,4.4-5.3-1.6  s2.8-10.9,3.5-17.5c0.7-6.6-3.8-5.3-9.7,1.4c0,0-4-4.5-11.1,3.6c0,0,1.7-3.7-2.1-4.9c-3.8-1.2-2.7,3.5-5.1,8.7s-6.9,13.4-10.5,12  s-2.6-6,1.1-14.2c3.7-8.2,2.9-9.3,1.5-10.1s-5.5,1-8.4,11.6s-7.5,12.3-9.5,11.5c-2-0.8,1.1-11,4.2-16.8s-1.8-8.8-4.7-2.1  s-5,13.8-7.9,16.6c-2.9,2.9-7.8,2.4-6.7-4.9c0.9-5.9,3.1-7.8,4.7-9.7C152.6,151.7,153.5,150,151.9,148.7z M229.6,156.4  c0-5.4-5.9-1.9-7.6,0.6s-3.1,9.6-1,9.8C224.1,167.1,229.6,161.8,229.6,156.4z",
                "duration": 1400

            }
        ],
        "dimensions": {
            "width": 284,
            "height": 259
        }
    }
}; 
 
 
/* 
 Setup and Paint your lazyline! 

 
 $(document).ready(function(){ 
 $('#svg').lazylinepainter( 
 {
    "svgData": pathObj,
    "strokeWidth": 2,
    "strokeColor": "#fff"
}).lazylinepainter('paint'); 
 });
  */ 
 
 $(function(){
  //SVG設定
  
  var $svg_elems = $('#svg');　//タイトルSVG、矢印SVG
 $("body").delay(1000).queue(function(next) {
	  $svg_elems.lazylinepainter( 
	  {
		"svgData": pathObj,
		"strokeWidth": 2,　//線の太さ
		"strokeColor": "#fff",　//線の色
	  }).lazylinepainter('paint');
	  next();
  }).delay(2800).queue(function(next) {
	  $svg_elems.fadeOut(1000);
	  $('.logo').fadeIn(1000);
	  next();
  })
  //$('.logo').delay(4400).show();
  /**/

  //SVG設定
  /*
  var $svg_elems = $('#svg');　//タイトルSVG、矢印SVG
  $svg_elems.lazylinepainter( 
  {
    "svgData": pathObj,
    "strokeWidth": 2,　//線の太さ
    "strokeColor": "#fff"　//線の色
  });
  */
  
   //$svg_elems.lazylinepainter('paint');


});